import React from 'react';
import logo75 from '../assets/images/75Years.png';
import logo from '../assets/images/logo.png';
import hospital from '../assets/images/hospital.png';
import testMenu from '../assets/images/flask.png';
import qualitycheck from '../assets/images/good-quality.png';
import serviceCenter from '../assets/images/customer-support.png';


const TrustInfo = ({ data }) => {
    // const patientInfo = data?.data?.patientDetails || {};
    // const getCountry = () => {
    //     const Company = (patientInfo.Company || '').toUpperCase();
    //     if (Company === 'BANG') {
    //             return 'BANGLADESH';
    //     } else if (Company === 'NEP') {
    //         return 'NEPAL';
    //     } else {
    //         return 'BHARAT';
    //     }
    // };
    // const country = getCountry();
    

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col d-flex align-items-center pt-2 pb-2 header">
                        <div>
                            <img className="img-fluid logo-75" src={logo75} />
                        </div>
                        <div className="ms-auto">
                            <img className="img-fluid logo-lal" alt="Dr. Lal Pathlabs" src={logo} />
                        </div>
                    </div>
                </div>
                <div className="row last-page-content-wrapper" >
                    <div className="container-1 ">
                        <div className="custom-center">
                            <div className="tagline">
                                {/* BHARAT  */}
                                 {/* {country} */}
                               BHARAT KA <br /> <span>VISHWAS</span>
                            </div>

                            <div className="about-success">
                                <div>
                                    <img alt="" src={hospital} />
                                    <div className="count">11K+</div>
                                    <div className="count-name">Hospital & Clinic Partners</div>
                                </div>
                                <div>
                                    <img alt="" src={testMenu} />
                                    <div className="count">~5K</div>
                                    <div className="count-name">Test Menu</div>
                                </div>
                                <div>
                                    <img alt="" src={qualitycheck} />
                                    <div className="count">50+</div>
                                    <div className="count-name">Quality Checks</div>
                                </div>
                                <div>
                                    <img alt="" src={serviceCenter} />
                                    <div className="count">6K+</div>
                                    <div className="count-name">Patient
                                        Service Centres</div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )

}

export default TrustInfo;